import React from 'react'
import { ApiStore } from './index'

export function connectApi(component) {
  return props => <ApiStore>{apiState => React.createElement(component, { ...props, ...apiState })}</ApiStore>
}
